import { Heading, VStack, Box, HStack, Text, Divider } from "@chakra-ui/react";
import { SiteStats } from "../../types/dashboardData";
import { ColorContext, useSiteColor } from "../SiteColorsProvider/SiteColorsProvider";

export function SitesStatistics({
  sitesStats,
  unit,
  title,
  colorContext,
}: {
  sitesStats: SiteStats[];
  unit: string;
  title?: string;
  colorContext: ColorContext;
}) {
  const defaultTitle = "Site Statistics";
  return (
    <VStack alignItems={"flex-start"} gap={4} height={"100%"}>
      <Heading size="md" width="100%">
        {title || defaultTitle}
      </Heading>
      <VStack width="100%" overflowY={"auto"}>
        {sitesStats.map((siteStats) => (
          <SiteStatistic key={siteStats.siteName} unit={unit} siteStats={siteStats} colorContext={colorContext} />
        ))}
      </VStack>
    </VStack>
  );
}

function SiteStatistic({
  siteStats,
  unit,
  colorContext,
}: {
  siteStats: SiteStats;
  unit: string;
  colorContext: ColorContext;
}) {
  const { siteMean, siteMin, siteMax, siteName, samples } = siteStats;
  const siteColor = useSiteColor(siteName, colorContext);

  return (
    <Box borderLeft={`8px solid ${siteColor}`} width="100%">
      <VStack border="1px" alignItems={"center"} width="100%" gap={1.5}>
        <Heading size="sm">{siteName}</Heading>
        <HStack borderTop="1px" gap={0} width="100%" justifyContent={"stretch"}>
          <StatName>Mean</StatName>
          <DividerBorder />
          <StatValue>{`${siteMean.toFixed(2)} ${unit}`}</StatValue>
          <DividerBorder />

          <StatName>Min</StatName>
          <DividerBorder />
          <StatValue>{`${siteMin.toFixed(2)} ${unit}`}</StatValue>
          <DividerBorder />

          <StatName>Max</StatName>
          <DividerBorder />
          <StatValue>{`${siteMax.toFixed(2)} ${unit}`}</StatValue>

          <StatName>Samples</StatName>
          <DividerBorder />
          <StatValue>{`${samples}`}</StatValue>
        </HStack>
      </VStack>
    </Box>
  );
}

function DividerBorder() {
  return <Divider orientation="vertical" borderColor={"black"} />;
}

function StatName({ children }: { children: string }) {
  return (
    <Box background={"#EDF2F7"} padding={1.5} height={"100%"}>
      <Text as="b" fontSize={"sm"}>
        {children}
      </Text>
    </Box>
  );
}

function StatValue({ children }: { children: string }) {
  return (
    <Box padding={1.5}>
      <Text fontSize={"sm"}>{children}</Text>
    </Box>
  );
}
